// @ts-nocheck
import { useMutation, useQuery } from 'react-query'
import { Download, DatabaseBackup, RefreshCw, ShieldCheck } from 'lucide-react'
import { apiService } from '../services/api'
import { authService } from '../services/auth'

const Backups = () => {
  const user = authService.getUser()
  const isSuperAdmin = user?.role === 'superadmin'

  const { data, isLoading, refetch } = useQuery('backups', () => apiService.getBackups(), {
    enabled: isSuperAdmin,
    refetchInterval: 60000,
  })

  const createBackup = useMutation(() => apiService.createBackup(), {
    onSuccess: () => refetch(),
    onError: (error: any) => alert(error?.response?.data?.message || error?.response?.data?.error || 'Backup failed'),
  })

  if (!isSuperAdmin) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <div className="flex items-center gap-3 text-slate-700">
          <ShieldCheck className="h-5 w-5 text-slate-400" />
          <span>Superadmin access required.</span>
        </div>
      </div>
    )
  }

  const backups = data?.data || []
  const token = authService.getToken()

  const downloadUrl = (backupId: string, file: string) =>
    `/api/backups?action=download&id=${encodeURIComponent(backupId)}&file=${encodeURIComponent(file)}&token=${encodeURIComponent(token || '')}`

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">Backup Management</h2>
          <p className="text-slate-500">Superadmin-only application and database recovery backups</p>
        </div>
        <div className="flex gap-2">
          <button onClick={() => refetch()} className="inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm hover:bg-slate-50">
            <RefreshCw className="h-4 w-4" /> Refresh
          </button>
          <button
            onClick={() => createBackup.mutate()}
            disabled={createBackup.isLoading}
            className="inline-flex items-center gap-2 rounded-lg bg-sky-600 px-4 py-2 text-sm text-white hover:bg-sky-700 disabled:opacity-60"
          >
            <DatabaseBackup className="h-4 w-4" />
            {createBackup.isLoading ? 'Creating...' : 'Create Backup'}
          </button>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Backup ID</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Created</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Files</th>
                <th className="px-4 py-3 text-right text-xs font-semibold uppercase text-slate-500">Download</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {isLoading ? (
                <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-500">Loading backups...</td></tr>
              ) : backups.length === 0 ? (
                <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-500">No backups found.</td></tr>
              ) : backups.map((backup: any) => (
                <tr key={backup.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-sm font-medium text-slate-900">{backup.id}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{backup.created_at}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-2">
                      {backup.files.map((file: any) => (
                        <span key={file.name} className="rounded-full bg-slate-100 px-2 py-1 text-xs text-slate-700">
                          {file.name} ({file.size_human})
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right">
                    {backup.files.map((file: any) => (
                      <a
                        key={file.name}
                        href={downloadUrl(backup.id, file.name)}
                        className="ml-2 inline-flex items-center gap-1 rounded-lg border px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100"
                      >
                        <Download className="h-4 w-4" /> {file.name.includes('full') ? 'Full' : file.name.split('.')[0]}
                      </a>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Backups
